import depList from './depList';
import departmentUser from './depUser';
import createDep from './createDep';
import deleteDep from './deleteDep';
import updateDep from './updateDep';
import setUserDep from './setUserDep';
import updateParentDep from './updateParentDep';
import departmentInfo from './departmentInfo';
import matchParentList from './matchParentList';
export default {
    /**  部门API  start */
    depList,
    departmentUser,
    createDep,
    deleteDep,
    updateDep,
    setUserDep,
    updateParentDep,
    departmentInfo,
    matchParentList
    /**  部门API  end */
};



// WEBPACK FOOTER //
// ./src/api/systemManage/department/index.ts